module.exports = __webpack_public_path__ + "img/plan.7b7c160e.png";